import { CAlert, CCol } from '@coreui/react-pro'
import { Effect } from 'effector'
import { useApiResult } from './hooks'

type ApiResultProps<Params, Done, Fail> = {
  effect: Effect<Params, Done, Fail>
  successMessage?: string
}

export function ApiResult<Params, Done, Fail>({
  effect,
  successMessage,
}: ApiResultProps<Params, Done, Fail>) {
  const { success, error } = useApiResult(effect)

  if (!success && !error) return null

  return (
    <CCol xs={12} className="mb-2">
      {success && (
        <CAlert color="success">
          {successMessage || 'Operation successful'}
        </CAlert>
      )}
      {error && (
        <CAlert color="danger">
          {error.code ? `Error ${error.code}: ${error.message}` : error.message}
        </CAlert>
      )}
    </CCol>
  )
}
